import { render, staticRenderFns } from "./JourneyBuilderComposer.vue?vue&type=template&id=75050726&scoped=true&"
import script from "./JourneyBuilderComposer.vue?vue&type=script&lang=js&"
export * from "./JourneyBuilderComposer.vue?vue&type=script&lang=js&"
import style0 from "../../Style/journey-builder-composer.scss?vue&type=style&index=0&id=75050726&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75050726",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("n:\\Projects\\Werk\\MarketingDbNEW\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('75050726')) {
      api.createRecord('75050726', component.options)
    } else {
      api.reload('75050726', component.options)
    }
    module.hot.accept("./JourneyBuilderComposer.vue?vue&type=template&id=75050726&scoped=true&", function () {
      api.rerender('75050726', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Composer/JourneyBuilderComposer.vue"
export default component.exports